import axios, { AxiosInstance } from 'axios';
import { config } from 'utils/config';

export const API_DEPRECATED: AxiosInstance = axios.create({
  baseURL: config.env.VITE_API_URL_DEPRECATED,
});
